import { styled } from 'solid-styled-components';
import { defaultTextStyle, normal } from '../../../ui-components/text/text.styles';
import theme, { fontFamilyAtosBold, fontFamilyAtosLight, fontFamilyAtosRegular } from '../../../style/theme';

export const StyledLeftArea = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.darkGray};
    height: 100%;
    box-sizing: border-box;
    padding: 3rem 6rem 0 0;
    position: relative;
    ${theme.mediaQueries.desktopMax} {
        padding: 3rem 3rem 0 0;
    }
`;

export const StyledLoginMenuRightArea = styled.div`
    height: 100vh;
    overflow: scroll;
    overflow-x: hidden;

    ${theme.mediaQueries.tabletMaxOriginal} {
        padding-left: 0rem;
    }

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const userProfileGridStyle = `
    display: grid;
    grid-template-rows: auto;
    height: fit-content;
    column-gap: ${theme.grid.gapSize}rem;
    row-gap: ${theme.grid.standardUnit}rem;

    ${theme.mediaQueries.tabletMax} {
        column-gap: ${theme.grid.gapSizeMobile}rem;
    }

    ${theme.mediaQueries.mobileMax} {
        column-gap: ${theme.grid.mobileColumnGap}rem;
        row-gap: ${theme.grid.gapSizeTabletSmall}rem;
    }

    grid-template-columns: repeat(${3}, 1fr);

    @container (max-width: ${859}px) {
        grid-template-columns: repeat(${2}, 1fr);
    }

    @container (max-width: ${theme.breakpoints.TABLET}px) {
        grid-template-columns: repeat(${1}, 1fr);
    }
`;

export const StyledBottomFade = styled.div`
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7.27rem;
    pointer-events: none;
    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
`;

export const StyledLoginMenuHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 3rem 0 1rem 0;
    position: sticky;
    right: 0;
    top: 0;
    z-index: 2;
`;

export const StyledEmptyColumn = styled.div``;

// a little hacky but working fix for our need of dual colors
// in background row of menu.
export const StyledLoginMenuLeftBackgroundPanel = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 10000px;
    margin-left: -10000px;
    background-color: ${theme.palette.darkGray};
`;

// Really stupid stuff that is needed for the loginMenu close button
// to look similar to the desktop menu
export const StyledSpacer = styled.div`
    height: 6.55rem;
    padding-top: 2rem;
`;

export const StyledWelcomeText = styled.div`
    margin-top: 50%;
    margin-bottom: 25%;
`;

export const StyledDivider = styled.div`
    border-bottom: 0.18rem solid #fff;
`;

export const StyledLoginInstruction = styled.p`
    font-size: 1.82rem;
    font-family: ${fontFamilyAtosLight};
    font-weight: normal;
    color: #fff;
    margin-top: 3rem;
`;

export const StyledSignedInStatus = styled.div<{ usePadding: boolean | undefined }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    ${(p) =>
        p.usePadding
            ? `
        padding: 0.5rem 1.43rem;
    `
            : ''}
`;

export const StyledSignedInAs = styled.button`
    font-size: 1.1rem;
    color: ${theme.colors.text.red};
    display: flex;
    flex-direction: column;
    cursor: pointer;
`;

export const StyledSignedInAsBold = styled.span`
    font-weight: bold;
`;

export const StyledSignOut = styled(StyledSignedInAs)`
    font-weight: bold;
`;

export const StyledLoginMenuSignedInAs = styled.div`
    font-size: 1.36rem;
    color: ${theme.palette.white};
    display: flex;
    flex-direction: column;

    ${theme.mediaQueries.tabletMaxOriginal} {
        font-size: 1.1rem;
    }
`;

export const StyledLoginMenuSignedInAsBold = styled(StyledLoginMenuSignedInAs)`
    font-weight: bold;
    margin-bottom: 0.5rem;
`;

export const StyledLoginMenuSignedInAsContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-top: auto;
    margin-bottom: 3rem;
    word-break: break-word;
`;

export const StyledNavigation = styled.nav`
    margin-top: 9rem;
`;

export const StyledSidebarNavigationSection = styled.div`
    margin-top: 6rem;

    ${theme.mediaQueries.tabletMaxOriginal} {
        margin-top: 6rem;
    }
`;

export const StyledNavigationSectionHeader = styled.div`
    ${defaultTextStyle}
    ${normal}
    color: ${theme.palette.white};

    border-bottom: 1px solid ${theme.palette.white};
    padding-bottom: 1rem;
    margin-bottom: 2.65rem;
    
    ${theme.mediaQueries.tabletMaxOriginal} {
        font-size: 1.3rem;
        padding-bottom: 0.8rem;
    }
`;

export const StyledNavItem = styled.div`
    margin-bottom: 2rem;
`;

export const StyledNavButton = styled.button<{ active?: boolean }>`
    ${defaultTextStyle}
    ${normal}
    display: flex;
    align-items: center;
    gap: 1.15rem;
    line-height: 1.3em;
    color: ${theme.palette.white};
    text-align: left;
    font-family: ${(props) => (props.active ? fontFamilyAtosBold : fontFamilyAtosRegular)};
    opacity: 1;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.7;
    }

    ${theme.mediaQueries.tabletMaxOriginal} {
        font-size: 1.3rem;
        line-height: normal;
        gap: 0.9rem;
    }
`;

export const StyledContentWrapper = styled.div`
    padding-top: 1.5rem;
    padding-right: 1rem;
`;

export const StyledUserMenuGrid = styled.div`
    height: 100%;
    display: grid;
    grid-template-rows: auto;
    height: fit-content;
    column-gap: ${theme.grid.gapSizeTablet}rem;
    row-gap: ${theme.grid.standardUnit}rem;

    ${theme.mediaQueries.tabletMaxOriginal} {
        column-gap: ${theme.grid.gapSize}rem;
    }

    grid-template-columns:
        3fr 9fr;

    ${theme.mediaQueries.tabletMax} {
        grid-template-columns:
            1fr;
    }
`;

